export default __webpack_public_path__ + "82bfebbd88189f35f7ba72ea0f491ac7.png";